import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/PosmotriteVideo.module.scss'

import { Container, Image, Modal } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'

class PosmotriteVideo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      show_video_modal: false,
      currentVideo: null
    }
  }

  openVideoModal = (video) => {
    this.setState({ 
      show_video_modal: true,
      currentVideo: video
    });
  }

  closeVideoModal = () => {
    this.setState({ 
      show_video_modal: false,
      currentVideo: null
    });
  }

  extractVideoId(url) {
    if (!url) return null;
    
    // Проверяем Rutube
    const rutubeRegExp1 = /rutube\.ru\/video\/([a-zA-Z0-9]+)/;
    const rutubeRegExp2 = /rutube\.ru\/play\/embed\/([a-zA-Z0-9]+)/;
    
    const rutubeMatch1 = url.match(rutubeRegExp1);
    const rutubeMatch2 = url.match(rutubeRegExp2);
    
    if (rutubeMatch1 && rutubeMatch1[1]) return { type: 'rutube', id: rutubeMatch1[1] };
    if (rutubeMatch2 && rutubeMatch2[1]) return { type: 'rutube', id: rutubeMatch2[1] };
    
    // Проверяем YouTube (обычные видео)
    const youtubeRegExp1 = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const youtubeRegExp2 = /youtube\.com\/embed\/([^"&?\/\s]{11})/;
    
    const youtubeMatch1 = url.match(youtubeRegExp1);
    const youtubeMatch2 = url.match(youtubeRegExp2);
    
    if (youtubeMatch1 && youtubeMatch1[1]) return { type: 'youtube', id: youtubeMatch1[1] };
    if (youtubeMatch2 && youtubeMatch2[1]) return { type: 'youtube', id: youtubeMatch2[1] };
    
    // Проверяем YouTube Shorts
    const shortsRegExp = /youtube\.com\/shorts\/([^"&?\/\s]{11})/;
    const shortsMatch = url.match(shortsRegExp);
    
    if (shortsMatch && shortsMatch[1]) return { type: 'youtube', id: shortsMatch[1] };
    
    return null;
  }

  getEmbedUrl(videoInfo) {
    if (!videoInfo) return null;
    
    if (videoInfo.type === 'rutube') {
      return `https://rutube.ru/play/embed/${videoInfo.id}/`;
    } else if (videoInfo.type === 'youtube') {
      return `https://www.youtube.com/embed/${videoInfo.id}`;
    }
    
    return null;
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {
    const { data, assets_path, margin } = this.props
    const { show_video_modal, currentVideo } = this.state;

    const videoInfo = currentVideo?.link ? this.extractVideoId(currentVideo.link) : null;
    const embedUrl = videoInfo ? this.getEmbedUrl(videoInfo) : '';

    return (
      <section className={`${styles.section} ${styles[margin]}`}>
        <Container>
          <WhiteBlockTitle
            title={data?.title || ``}
            text={data?.rtext || ``}
            className={styles.title}
          />
          <div className={styles.text} dangerouslySetInnerHTML={{__html: data?.text}} />
          <div className={styles.list}>
            {data?.list.map( ( slyde, index ) => (
              <div key={index} className={styles.slyde}>
                <div className={styles.slyde_img}>
                  <Image src={slyde?.image} alt={slyde?.name} width={386} height={220} />
                  <div className={styles.slyde_head}>
                    <div>GOODWIN</div>
                    <div className={styles.slyde_head_sep} />
                    <div>{this.formatSlideNumber(index)}</div>
                  </div>
                  {/* Заменяем ссылку на div с обработчиком клика */}
                  <div 
                    className={styles.slyde_btn}
                    onClick={() => this.openVideoModal(slyde)}
                    role="button"
                    tabIndex={0}
                    onKeyUp={(e) => e.key === 'Enter' && this.openVideoModal(slyde)}
                  >
                    <GreenButton
                      text={`Смотреть видео`}
                      width={145}
                      svg={(
                        <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.5 4.63397C9.16667 5.01888 9.16667 5.98113 8.5 6.36603L1.75 10.2631C1.08333 10.648 0.25 10.1669 0.25 9.39711L0.250001 1.60289C0.250001 0.833085 1.08333 0.35196 1.75 0.73686L8.5 4.63397Z" fill="#00C775"/>
                        </svg>
                      )}
                    />
                  </div>
                </div>
                <div className={styles.slyde_type}>{slyde?.type}</div>
                <div className={styles.slyde_name}>{slyde?.name}</div>
              </div>
            ))}
            <div className={styles.last_slyde}>
              <div className={styles.last_slyde_fline}>
                <div className={styles.last_slyde_title}>
                  Больше видео<br />
                  <span>на нашем RUTUBE канале</span>
                </div>
                <div>{this.formatSlideNumber(2)}</div>
              </div>
              <div className={styles.last_slyde_text}>
                Мы публикуем полезные видеоролики на RUTUBE, где подробно показываем возможности и особенности наших решений.
              </div>
              <GreenButton
                text={`Перейти на RUTUBE канал`}
                width={213}
                svg={(
                  <Image src={`/${assets_path}/images/rutube.svg`} width={15} height={15} alr={`R`} />
                )}
                href={`https://rutube.ru/channel/44122110/`}
                target={`_blank`}
              />
            </div>
          </div>
          <div className={styles.last_slyde_mob}>
            <div className={styles.last_slyde_fline}>
              <div className={styles.last_slyde_title}>
                Больше видео<br />
                <span>на нашем RUTUBE канале</span>
              </div>
              <div>{this.formatSlideNumber(2)}</div>
            </div>
            <div className={styles.last_slyde_text}>
              Мы публикуем полезные видеоролики на RUTUBE, где подробно показываем возможности и особенности наших решений.
            </div>
            <GreenButton
              text={`Перейти на RUTUBE канал`}
              width={213}
              svg={(
                <Image src={`/${assets_path}/images/rutube.svg`} width={15} height={15} alr={`R`} />
              )}
              href={`https://rutube.ru/channel/44122110/`}
              target={`_blank`}
            />
          </div>

          {/* Модальное окно для видео */}
          <Modal 
            show={show_video_modal} 
            onHide={this.closeVideoModal}
            size="lg"
            centered
            className={styles.video_modal}
          >
            <Modal.Header closeButton>
              <Modal.Title>{currentVideo?.name || 'Видео'}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
              {embedUrl ? (
                <div className={styles.video_container}>
                  <iframe
                    src={embedUrl}
                    width="100%"
                    height="405"
                    frameBorder="0"
                    style={{ border: 'none' }}
                    allow="clipboard-write; autoplay"
                    webkitAllowFullScreen
                    mozallowfullscreen
                    allowFullScreen
                    title={currentVideo?.name || 'Видео'}
                  />
                </div>
              ) : (
                <p>Неверная ссылка на видео</p>
              )}
            </Modal.Body>
          </Modal>
        </Container>
      </section>
    )
  }
}

PosmotriteVideo.propTypes = {
  data: PropTypes.object,
  assets_path: PropTypes.string,
  margin: PropTypes.string
}

PosmotriteVideo.defaultProps = {
  data: {},
  assets_path: ``,
  margin: `top`
}

export default PosmotriteVideo